import {
  BellPlus,
  Columns3,
  HousePlus,
  MessageSquare,
  Settings,
  type LucideIcon,
} from "lucide-react";

export type DashboardLinkId =
  | "listings"
  | "search-alerts"
  | "tracker"
  | "tool"
  | "settings";

export type DashboardLink = {
  id: DashboardLinkId;
  href: string;
  icon: LucideIcon;
};

export const DASHBOARD_HOME_HREF = "/dashboard";

export const dashboardLinks: DashboardLink[] = [
  {
    id: "listings",
    href: "/dashboard/tenant/listing",
    icon: HousePlus,
  },
  {
    id: "tracker",
    href: "/dashboard/tenant/tracker",
    icon: Columns3,
  },
  {
    id: "search-alerts",
    href: "/dashboard/tenant/search-alert",
    icon: BellPlus,
  },
  {
    id: "tool",
    href: "/dashboard/tenant/tool/smart-message",
    icon: MessageSquare,
  },
  {
    id: "settings",
    href: "/dashboard/tenant/settings",
    icon: Settings,
  },
];
